import { ALL_OFFLINESTORE_COMPANY_FAIL, ALL_OFFLINESTORE_COMPANY_REQUEST, ALL_OFFLINESTORE_COMPANY_SUCCESS, ALL_OFFLINESTORE_FAIL, ALL_OFFLINESTORE_REQUEST, ALL_OFFLINESTORE_SUCCESS } from "app/utils/constants/offlineStore";



const INIT_STATE = {
  branch: {
    loading: false,
    error: null,
    allBranch: [],
    TotalPage: null,
  },
  company: {
    loading: false,
    error: null,
    allCompany: [],
    TotalPage: null,
  }
};

export const offlineStoreReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ALL_OFFLINESTORE_REQUEST:
      return { ...state, branch: { ...state.branch, loading: true } };
    case ALL_OFFLINESTORE_SUCCESS:
      return {
        ...state,
        branch: {
          ...state.branch,
          loading: false,
          allBranch: action.payload.data,
          TotalPage: action.payload.totalPage,
        }
      };
    case ALL_OFFLINESTORE_FAIL:
      return {
        ...state, branch: {
          ...state.branch,
          loading: false,
          allRoles: [],
          error: action.payload
        }
      };
    case ALL_OFFLINESTORE_COMPANY_REQUEST:
      return { ...state, company: { ...state.company, loading: true } };
    case ALL_OFFLINESTORE_COMPANY_SUCCESS:
      return {
        ...state, company: {
          ...state.company,
          loading: false,
          allCompany: action.payload.data,
          TotalPage: action.payload.totalPage
        }
      };
    case ALL_OFFLINESTORE_COMPANY_FAIL:
      return {
        ...state, company: {
          ...state.company,
          loading: false,
          allCompany: [],
          error: action.payload
        }
      }
    default:
      return state;
  }
};

